module.exports = __webpack_public_path__ + "img/category-spellcasting.58fc3bba.svg";